// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import { Loader } from "semantic-ui-react";

import { useUserAuth } from "../../../hooks/useUserAuth";

const Home = () => {
	const userAuth = useUserAuth();
	useEffect(() => {
		if (userAuth.isReady) {
			userAuth.goHome();
		}
	}, [userAuth.isReady]);

	return <Loader active />;
};

export default Home;
